export const getCountries = async (welletContext) => {
  return await welletContext.apis.admin.get(`api/location/countries`);
};

export const getStates = async (welletContext, country) => {
  return await welletContext.apis.admin.get(`api/location/state/${country}`);
};
export const getCities = async (welletContext, state) => {
  return await welletContext.apis.admin.get(`api/location/city/${state}`);
};